import classNames from 'classnames';
import I18n from 'i18n-js';

import Markdown from '~/components/Markdown';

import styles from './Body.module.scss';

export default function Body() {
  return (
    <>
      <span className={classNames(styles.text, styles.title)}>
        {I18n.t('subscription_summary_bs_discord_headline')}
      </span>
      <Markdown className={classNames(styles.textBasic, styles.text)}>
        {I18n.t('subscription_summary_discord')}
      </Markdown>
      <Markdown className={classNames(styles.textBasic, styles.href)}>
        {I18n.t('subscription_summary_discord_terms')}
      </Markdown>
    </>
  );
}
